'use strict';

var moment = require('moment');
var buildSimpleValidator = require('./helpers/build-simple-validator');

var dateFormats = ['YYYY-MM-DD[T]HH:mm:ssZ', 'YYYY-MM-DD[T]HH:mm:ss', 'MM/DD/YYYY', 'M/D/YYYY'];

module.exports = buildSimpleValidator(function (value) {
  return moment(value, dateFormats, true).isValid();
}, 'Value must be a valid date');